import React from 'react'
import Navbar from '../../components/Navbar/Navbar'
import styles from './HomePage.module.css'

export const HomePage = () => {
  return (
    <div className={styles.main}>
        <Navbar/>
    </div>
  )
}
